import { handleActions } from 'redux-actions';
import { UserActions } from 'app/actions/user/userAction.ts';
import type { UserDto } from '@/api-gen/api.schemas';
import { LoadingStatus } from 'app/store/types.ts';
import type { CurrentUserLoadError } from 'app/types/user.ts';

export interface IUserState {
  currentUser?: UserDto;
  currentUserNotFound: boolean;
  currentUserLoadingStatus: LoadingStatus;
  currentUserLoadError: CurrentUserLoadError | null;
}

const initialState: IUserState = {
  currentUser: null,
  currentUserNotFound: false,
  currentUserLoadingStatus: LoadingStatus.Idle,
  currentUserLoadError: null
};

export const userReducer = handleActions<IUserState, UserDto | Date | boolean>(
  {
    [UserActions.Type.SET_CURRENT_USER]: (state, action): IUserState => {
      return { ...state, currentUser: action.payload as UserDto };
    },
    [UserActions.Type.SET_CURRENT_USER_LOADING_STATUS]: (state, action): IUserState => {
      return { ...state, currentUserLoadingStatus: (action.payload as unknown) as LoadingStatus };
    },
    [UserActions.Type.SET_CURRENT_USER_NOT_FOUND]: (state): IUserState => {
      return { ...state, currentUserNotFound: true };
    },
    [UserActions.Type.SET_CURRENT_USER_LOAD_ERROR]: (state, action): IUserState => {
      return { ...state, currentUserLoadError: (action.payload as CurrentUserLoadError) ?? null };
    }
  },
  initialState
);
